import { PremiumOverviewContainer } from '../PremiumOverviewContainer/PremiumOverviewContainer'

export const ActiveEnergyManagement = () => {
    return <PremiumOverviewContainer />
}
